import _ from 'underscore';
import Handlebars from 'handlebars';
import Marionette from 'backbone.marionette';
import Ace from 'ace-builds/src-noconflict/ace';
import mode from '@/lib/ace/mode/electricimp';
import theme_idle_fingers from 'ace-builds/src-noconflict/theme-idle_fingers';
import theme_github from 'ace-builds/src-noconflict/theme-github';
import template from '@/../templates/code-editor.hbs';
import searchbox from 'ace-builds/src-noconflict/ext-searchbox';

import settings_menu from 'ace-builds/src-noconflict/ext-settings_menu'; // eslint-disable-line
searchbox;

// Ace editor annotations are 0-indexed, errors/warnings are 1-indexed.
function fix_annotation_rows(annotations) {
    return annotations.map(function(annotation) {
        var modified_annotation = _.clone(annotation);
        modified_annotation.row--;
        return modified_annotation;
    });
}

var CodeEditorView = Marionette.View.extend({
    className: 'code-editor-pane',
    template: Handlebars.compile(template),
    ui: {
        editor: '.code-editor'
    },
    triggers: {
        'focus @ui.editor': 'focus',
        'keydown @ui.editor': {
            event: 'keydown',
            preventDefault: false,
            stopPropagation: false,
        },
    },
    templateContext: function() {
        return this.options;
    },
    initialize: function(options) {
        this.mergeOptions(options, ['settings', 'type']);

        this.listenTo(this.settings, 'change:theme', function(settings, theme) {
            this.set_theme(theme);
        });

        this.listenTo(this.settings, 'change:tabSize', function(settings, tab_size) {
            this.set_tab_size(tab_size);
        });
    },
    create_editor: function(code) {
        this.editor = Ace.edit(this.ui.editor.get(0));
        var self = this;
        this.editor.commands.addCommand({
            name: 'build',
            bindKey: {
                win: 'ctrl-s',
                mac: 'command-s',
                sender: 'editor|cli'
            },
            exec: function () {
                self.triggerMethod('build');
            }
        }); 

        var theme = this.settings && this.settings.get('theme');
        if (theme) {
            this.set_theme(theme);
        }
        this.set_read_only(this.options.read_only);
        // Comply with warning from ACE Editor:
        //     Automatically scrolling cursor into view after selection
        //     change this will be disabled in the next version set
        //     editor.$blockScrolling = Infinity to disable this message
        //
        this.editor.$blockScrolling = Infinity;

        var session = this.editor.getSession();
        session.setUseSoftTabs(true);
        session.setMode(new mode());
        // error when code is undefined, so set to empty string
        if ( !code ) code = '';
        session.setValue(code);
    },
    resize: function() {
        this.editor.resize();
    },
    onRender: function() {
        // Uninitialized drafts will have null values for
        // agent_code and device_code, but null will break Ace Editor
        // when we call setValue; therefore empty string is a fallback OR
        // in case there is a latest deployment, set that value

        // when code_model (this.model) is not populated yet, wait for it..
        // and try again
        if ( this.model.get(this.type + '_code') === undefined ) {
            this.$el.hide();
            this.model.on('sync', function(){
                this.$el.show();
                this.onRender();
            }.bind(this));
        }

        var code = this.model.get(this.type + '_code') || '';
        this.create_editor(code);
        this.start_editor_listeners();
        this.set_theme(this.settings.get('theme'));
    },
    on_editor_change: function(e) {
        this.model.set(this.type + '_code', this.editor.getValue());
    },
    start_editor_listeners: function() {
        this.editor.getSession().on('change', this.on_editor_change.bind(this));
    },
    set_read_only: function(read_only) {
        this.editor.setReadOnly(read_only);

        if (read_only) {
            this.$el.addClass('read-only');
        } else {
            this.$el.removeClass('read-only');
        }
    },
    set_theme: function(theme_string) {
        if (theme_string === 'ide_fingers'){
            this.editor.setTheme(theme_idle_fingers);
        } else if (theme_string === 'github') {
            this.editor.setTheme(theme_github);
        } else {
            this.editor.setTheme(theme_idle_fingers);
        }
        this.triggerMethod('set_theme', theme_string);
    },
    set_tab_size: function(tab_size) {
        if (!tab_size) {
            tab_size = 4;
            this.settings.set('tabSize', tab_size);
        }
        this.editor.getSession().setTabSize(parseInt(tab_size, 10));
    },
    handle_syntax_check_results: function(results) {
        var session = this.editor.getSession();
        session.clearAnnotations();
        if (results.length === 0) { return; }

        session.setAnnotations(fix_annotation_rows(results));

        // Move cursor to first error only, dont jump to warnings
        var first = _(results).sortBy('row')[0];
        if (first.type === 'error') {
            this.editor.gotoLine(first.row + 1, first.column);
        }
    }
});

export default CodeEditorView;
